"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'userGroup.error.create': '创建用户组失败',
};
